<template>
    <v-container>
         <v-row
            align="center"
            justify="center"
        >
            <img
                class="elevation-1 rounded-circle"
                height="128"
                width="128"
                src="/logologin.jpeg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Creación de usuario
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                           <v-text-field
                                label="Nombre de usuario"
                                type="text"
                                outlined
                                dense
                                v-model="username"
                                :rules="userRules"
                                required
                            ></v-text-field>

                            <v-text-field
                                label="Contraseña"
                                outlined
                                dense
                                v-model="password"
                                :rules="passRules"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                required
                            ></v-text-field>
                            <v-text-field
                                label="Confirmacion contraseña"
                                outlined
                                dense
                                v-model="confirmPassword"
                                :rules="confirmPasswordRules"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                required
                            ></v-text-field>
                        </v-form>
                        <div align="center" style="color:red">
                            {{errorLogin}}
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="!successRegister"
                            width="95%"
                            color="success"
                            class="ma-2"
                            :loading="isLoading"
                            @click="createUser"
                            :disabled="!valid"
                        >
                            Crear
                        </v-btn>
                        <v-btn
                            v-else
                            width="95%"
                            color="success"
                            class="ma-2"
                            @click="goLogin"
                            :disabled="!valid"
                        >
                            Ir login
                        </v-btn>
                    </v-card-actions>
                    <v-card-text align="center">
                        ¿Tienes alguna duda? <a> Contactanos </a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics 
            </p>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
        name: 'CreateUser',
        

		data: () => ({
            valid: false,
            username: '',
            password: '',
            confirmPassword: '',
            showPass: false,
             userRules: [
                v => !!v || 'Usuario es requerido',
                v => (v && v.length > 5) || 'Nombre de usuario debe tener mas de 5 caracteres',
                v => /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/.test(v) || "Solo puede tener letras, numeros y '_'",
            ],
            passRules: [
                v => !!v || 'Password requerido',
                v => (v && v.length > 6) || 'Password debe tener mas de 8 caracteres',
            ],
		}),

		methods: {
			createUser () {
                const payload = {
                    username: this.username.toLowerCase().trim(),
                    password: this.password,
                    token: this.token
                }

                const isValid = this.$refs.form.validate()

                if (isValid)
                    this.$store.dispatch('register', payload)
            },
			goLogin () {
                this.$router.push('/login')
            }
		},

		computed: {
            token () {
                return this.$route.query.token
            },
            isLoading () {
                return this.$store.getters.loadRegister
            },
            errorRegister () {
                return this.$store.getters.errorRegister
            },
            successRegister () {
                return this.$store.getters.successRegister
            },
            confirmPasswordRules() {
                return [
                    v => !!v || 'Confirmar password',
                    v => v === this.password || 'Password no coinciden',
                ]
            },
            currentYear () {
                return moment().format("YYYY")
            }
		},

        filters: {
            lowerCase (value) {
                if (!value) return ''
                value = value.toString()
                return value.toLowerCase().trim()
            }
        },

		created () {
			moment.locale('es-us')
		}

	}
</script>
